import { createContext, useContext } from 'react';

type BranchContext = {
  Branch?: Function;
  isLoading: boolean;
};

const defaultValue: BranchContext = {
  isLoading: true,
};

const context = createContext(defaultValue);
const { Provider } = context;
const useBranch = (): BranchContext => useContext(context);

export { BranchContext, Provider, defaultValue, useBranch };
